/**
 * Velora Modern's one status chip (navigation review P0, docs/ux): the
 * timeclock, the capture/sensor pill and the "automations off" hint share one
 * compact group in the top bar instead of three separate controls, so the top
 * bar holds at most seven items (office, patient, search, sync, status, bell,
 * user). Each segment renders nothing when it has nothing to say; the group
 * collapses when every segment is empty (CSS :empty).
 *
 * Phone width (mobile audit 2026-10-21): the group moves behind one "More"
 * button so the office name and the bell are not squeezed to a sliver.
 */
import { Popover } from '@velora/ui';
import { MoreHorizontal } from 'lucide-react';
import { AutomationsIndicator } from './AutomationsIndicator.js';
import { GlobalSensorPill } from './GlobalHosts.js';
import { usePhone } from './narrow.js';
import { TimeclockChip } from './TimeclockButton.js';

function Segments() {
  return (
    <>
      <TimeclockChip />
      <GlobalSensorPill />
      <AutomationsIndicator compact />
    </>
  );
}

export function StatusChip() {
  const phone = usePhone();
  if (phone) {
    return (
      <Popover
        label="Status: time clock, capture and automations"
        align="end"
        className="shell-status-pop"
        trigger={
          <button
            type="button"
            className="shell-iconbtn shell-status-more"
            aria-label="More: time clock, capture and automations"
            data-testid="topbar-more"
          >
            <MoreHorizontal size={18} aria-hidden />
          </button>
        }
      >
        <div className="shell-status shell-status--stacked" role="group" aria-label="Status">
          <Segments />
        </div>
      </Popover>
    );
  }
  return (
    <div className="shell-status" role="group" aria-label="Status">
      <Segments />
    </div>
  );
}
